<template>
  <el-table :data="simCardDataTable" stripe style="width: 100%" ref="simCardDataTable" border v-loading="listLoading">
    <!--                <af-table-column type="selection" width="30"></af-table-column>-->
    <af-table-column prop="businessName" :label="$t('ying-ye-shang-0')"></af-table-column>
    <af-table-column prop="packageType" :label="$t('tao-can')"></af-table-column>
    <af-table-column prop="flow" :label="$t('liu-liang-mb')"></af-table-column>
    <af-table-column prop="validityPeriod" :label="$t('you-xiao-qi')"></af-table-column>
    <af-table-column prop="cardNo" :label="$t('ka-hao')"></af-table-column>
    <af-table-column prop="stationName" :label="$t('chong-dian-zhan')"></af-table-column>
    <af-table-column prop="pileCode" :label="$t('alaramMonitor.pile')"></af-table-column>
    <af-table-column prop="operatorName" :label="$t('deviceControl.operatorId')"></af-table-column>
    <af-table-column prop="commissionerPhone" :label="$t('ping-tai-gong-zuo-ren-yuan-tong-zhi-dian-hua')"></af-table-column>
    <af-table-column prop="payType.message" :label="$t('fu-fei-lei-xing-0')"></af-table-column>

    <af-table-column :label="$t('deviceControl.operation')" width="240px">
      <template slot-scope="scope">
        <el-button size="mini" plain @click="simCardDetail(scope.$index, scope.row)">{{ $t('xiang-qing-0') }}</el-button>
        <el-button size="mini" @click="simCardEdit(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:simCard:updateSimCard'])">{{ $t('alaramMonitor.edit') }}
        </el-button>
        <el-button size="mini" type="danger" @click="simCardDelete(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:simCard:deleteSimCard'])">{{ $t('deviceControl.delete') }}
        </el-button>
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "list",
    data(){
      return{
      }
    },
    props:{
      simCardDataTable:{},
      listLoading:false,
    },
    methods:{
      simCardEdit(index,row){
        this.$emit("simCardEdit",index,row)
      },
      simCardDelete(index,row){
        this.$emit("simCardDelete",index,row)
      },
      simCardDetail(index,row){
        this.$emit("simCardDetail",index,row)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/simCardManager/list.vue